import { apiSlice } from "@/services/api-slice";
import { 
  Location, 
  CreateLocation, 
  UpdateLocation, 
  LocationPlace, 
  CreateLocationPlace, 
  UpdateLocationPlace,
  SettingsLocations,
  LocationSearch,
  ZoneLocation,
  CreateZoneLocation,
  UpdateZoneLocation,
  LocationBlockProduct,
  WarehouseLocationPlacesRequest
} from "./ubications.interface";
import { APIResponse } from "@/types/custom-http";


export const ubicationsApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
      // Obtener todos los Almacenes
      getLocations: builder.query<APIResponse<Location[]>, void>({
        query: () => ({
          url: "auth/warehouse/locale/location"
        }),
        providesTags: ["Location"],
      }),

      // Obtener Configuración de los Almacenes
      getSettingsLocations: builder.query<APIResponse<SettingsLocations>, void>({
        query: () => ({
          url: "auth/warehouse/locale/location/settings"
        }),
        providesTags: ["Location"],
      }),
      
      // Obtener un Almacén por ID
      getLocationById: builder.query<APIResponse<Location>, number>({
        query: (id) => ({ url:`auth/warehouse/locale/location/${id}`}),
        providesTags: (_result, _error, id) => [{ type: 'Location', id }],
      }),

      // Obtener un Almacén por ID
      getLocationsByProductId: builder.query<APIResponse<LocationBlockProduct[]>, {product_id: number, exclude_id: number}>({
        query: ({product_id, exclude_id}) => ({ url:`auth/warehouse/locale/location/product/${product_id}/exclude/${exclude_id}`}),
        providesTags: ["Location"],
      }),
      
      // Crear un nuevo Almacén
      createLocation: builder.mutation<APIResponse<Location>, CreateLocation>({
        query: (user) => ({
          url: 'auth/warehouse/locale/location',
          method: 'POST',
          body: user,
        }),
        invalidatesTags: ['Location'],
      }),

      // Buscar Almacenes
      searchLocations: builder.query<APIResponse<LocationSearch[]>, string>({
        query: (search) => ({
          url: `auth/warehouse/locale/location/search`,
          params: { search },
        }),
        providesTags: ["Location"],
      }),
      
      // Actualizar un Almacén existente
      updateLocation: builder.mutation<APIResponse<Location>, { id: number; changes: UpdateLocation }>({
        query: ({ id, changes }) => ({
          url: `auth/warehouse/locale/location/${id}`,
          method: 'PATCH',
          body: changes,
        }),
        invalidatesTags: (_result, _error, { id }) => [{ type: 'Location', id },'Location'],
      }),
      
      // Eliminar un Almacén
      deleteLocation: builder.mutation<APIResponse<null>, number>({
        query: (id) => ({
          url: `auth/warehouse/locale/location/${id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['Location'],
      }),

      // Obtener todas las Ubicaciones
      getLocationsPlaces: builder.query<APIResponse<LocationPlace[]>, void>({
        query: () => ({
          url: "auth/warehouse/locale/location-places"
        }),
        providesTags: ["LocationPlace"],
      }),

      
      // Obtener una Ubicación por ID
      getLocationPlaceById: builder.query<APIResponse<LocationPlace>, number>({
        query: (id) => ({ url:`auth/warehouse/locale/location-places/${id}`}),
        providesTags: (_result, _error, id) => [{ type: 'LocationPlace', id }],
      }),

      // Obtener una Ubicación por ID
      getLocationPlaceByWarehouseId: builder.query<APIResponse<LocationPlace[]>, WarehouseLocationPlacesRequest>({
        query: ({ id, stock_scope }) => ({
          url:`auth/warehouse/locale/location-places/warehouse/${id}`,
          params: stock_scope ? { stock_scope } : undefined,
        }),
        providesTags: (_result, _error, arg) => [{ type: 'LocationPlace', id: arg.id }],
      }),
      
      // Crear una nueva Ubicación
      createLocationPlace: builder.mutation<APIResponse<LocationPlace>, CreateLocationPlace>({
        query: (user) => ({
          url: 'auth/warehouse/locale/location-places',
          method: 'POST',
          body: user,
        }),
        invalidatesTags: ['LocationPlace'],
      }),
      
      // Actualizar una Ubicación existente
      updateLocationPlace: builder.mutation<APIResponse<LocationPlace>, { id: number; changes: UpdateLocationPlace }>({
        query: ({ id, changes }) => ({
          url: `auth/warehouse/locale/location-places/${id}`,
          method: 'PATCH',
          body: changes,
        }),
        invalidatesTags: (_result, _error, { id }) => [{ type: 'LocationPlace', id },'LocationPlace'],
      }),
      
      // Eliminar una Ubicación
      deleteLocationPlace: builder.mutation<APIResponse<null>, number>({
        query: (id) => ({
          url: `auth/warehouse/locale/location-places/${id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['LocationPlace'],
      }),

      // Obtener todas los Zonas de Almacén
      getZonesLocations: builder.query<APIResponse<ZoneLocation[]>, void>({
        query: () => ({
          url: "auth/warehouse/locale/zones"
        }),
        providesTags: ["LocationPlace"],
      }),

      
      // Obtener un Zona de Almacén por ID
      getZoneLocationById: builder.query<APIResponse<ZoneLocation>, number>({
        query: (id) => ({ url:`auth/warehouse/locale/zones/${id}`}),
        providesTags: (_result, _error, id) => [{ type: 'LocationPlace', id }],
      }),
      
      // Crear un nuevo Zona de Almacén
      createZoneLocation: builder.mutation<APIResponse<ZoneLocation>, CreateZoneLocation>({
        query: (user) => ({
          url: 'auth/warehouse/locale/zones',
          method: 'POST',
          body: user,
        }),
        invalidatesTags: ['LocationPlace'],
      }),
      
      // Actualizar un Zona de Almacén existente
      updateZoneLocation: builder.mutation<APIResponse<ZoneLocation>, { id: number; changes: UpdateZoneLocation }>({
        query: ({ id, changes }) => ({
          url: `auth/warehouse/locale/zones/${id}`,
          method: 'PATCH',
          body: changes,
        }),
        invalidatesTags: (_result, _error, { id }) => [{ type: 'LocationPlace', id },'LocationPlace'],
      }),
      
      // Eliminar un Zona de Almacén
      deleteZoneLocation: builder.mutation<APIResponse<null>, number>({
        query: (id) => ({
          url: `auth/warehouse/locale/zones/${id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['LocationPlace'],
      })

    }),
  });
  
  export const {
    useGetLocationsQuery,
    useGetLocationByIdQuery,
    useLazyGetLocationsByProductIdQuery,
    useGetSettingsLocationsQuery,
    useSearchLocationsQuery,
    useLazySearchLocationsQuery,
    useCreateLocationMutation,
    useUpdateLocationMutation,
    useDeleteLocationMutation,
    useGetLocationsPlacesQuery,
    useGetLocationPlaceByIdQuery,
    useGetLocationPlaceByWarehouseIdQuery,
    useLazyGetLocationPlaceByWarehouseIdQuery,
    useCreateLocationPlaceMutation,
    useUpdateLocationPlaceMutation,
    useDeleteLocationPlaceMutation,
    useGetZonesLocationsQuery,
    useGetZoneLocationByIdQuery,
    useCreateZoneLocationMutation,
    useUpdateZoneLocationMutation,
    useDeleteZoneLocationMutation
  } = ubicationsApi;
